
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebbe8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebbe8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $0f7d68994229b47d$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["lpLx5","associates.d1bae1b9.js","aXp1y","pcclogo.fc2996f5.png"]'));

var $803f78ba15bd16b6$exports = {};
$803f78ba15bd16b6$exports = new URL("pcclogo.fc2996f5.png", import.meta.url).toString();


const $fa81208e0a0a8f4a$var$carousel = document.querySelector(".cards-carousel");
const $fa81208e0a0a8f4a$var$associateDesc = document.querySelector(".associate__desc");
const $fa81208e0a0a8f4a$var$incrementBtn = document.querySelector(".carousel__next");
const $fa81208e0a0a8f4a$var$decrementBtn = document.querySelector(".carousel__prev");
let $fa81208e0a0a8f4a$var$cards = $fa81208e0a0a8f4a$var$carousel.querySelectorAll(".card-container");
let $fa81208e0a0a8f4a$var$currentIndex = 0;
let $fa81208e0a0a8f4a$var$moveCooldown = false;
let $fa81208e0a0a8f4a$var$autoPlay;
$fa81208e0a0a8f4a$var$setUpCarousel();
$fa81208e0a0a8f4a$var$incrementBtn.addEventListener("click", ()=>{
    if ($fa81208e0a0a8f4a$var$moveCooldown) return;
    clearInterval($fa81208e0a0a8f4a$var$autoPlay);
    $fa81208e0a0a8f4a$var$incrementCarousel();
    $fa81208e0a0a8f4a$var$moveCooldown = true;
    setTimeout(()=>{
        $fa81208e0a0a8f4a$var$moveCooldown = false;
    }, 300);
});
$fa81208e0a0a8f4a$var$decrementBtn.addEventListener("click", ()=>{
    if ($fa81208e0a0a8f4a$var$moveCooldown) return;
    clearInterval($fa81208e0a0a8f4a$var$autoPlay);
    $fa81208e0a0a8f4a$var$decrementCarousel();
    $fa81208e0a0a8f4a$var$moveCooldown = true;
    setTimeout(()=>{
        $fa81208e0a0a8f4a$var$moveCooldown = false;
    }, 300);
});
function $fa81208e0a0a8f4a$var$setUpCarousel() {
    const after = [
        $fa81208e0a0a8f4a$var$cards[0],
        $fa81208e0a0a8f4a$var$cards[1]
    ];
    $fa81208e0a0a8f4a$var$carousel.insertBefore($fa81208e0a0a8f4a$var$cards[$fa81208e0a0a8f4a$var$cards.length - 1].cloneNode(true), $fa81208e0a0a8f4a$var$carousel.children[0]);
    $fa81208e0a0a8f4a$var$carousel.appendChild(after[0].cloneNode(true));
    $fa81208e0a0a8f4a$var$carousel.appendChild(after[1].cloneNode(true));
    $fa81208e0a0a8f4a$var$cards = $fa81208e0a0a8f4a$var$carousel.querySelectorAll(".card-container");
    for(let i = 0; i < $fa81208e0a0a8f4a$var$cards.length; i++){
        const card = $fa81208e0a0a8f4a$var$cards[i];
        card.classList.add("no-transition");
    }
    $fa81208e0a0a8f4a$var$updateCarousel();
    for(let i = 0; i < $fa81208e0a0a8f4a$var$cards.length; i++){
        const card = $fa81208e0a0a8f4a$var$cards[i];
        card.offsetHeight;
        card.classList.remove("no-transition");
    }
    $fa81208e0a0a8f4a$var$autoPlay = setInterval(()=>{
        $fa81208e0a0a8f4a$var$incrementCarousel();
    }, 10000);
}
function $fa81208e0a0a8f4a$var$incrementCarousel() {
    $fa81208e0a0a8f4a$var$currentIndex++;
    if ($fa81208e0a0a8f4a$var$currentIndex >= 7) {
        $fa81208e0a0a8f4a$var$setIndex(0);
        $fa81208e0a0a8f4a$var$currentIndex++;
    }
    $fa81208e0a0a8f4a$var$updateCarousel();
}
function $fa81208e0a0a8f4a$var$decrementCarousel() {
    $fa81208e0a0a8f4a$var$currentIndex--;
    if ($fa81208e0a0a8f4a$var$currentIndex < 0) {
        $fa81208e0a0a8f4a$var$setIndex(6);
        $fa81208e0a0a8f4a$var$currentIndex--;
    }
    $fa81208e0a0a8f4a$var$updateCarousel();
}
function $fa81208e0a0a8f4a$var$setIndex(index) {
    $fa81208e0a0a8f4a$var$currentIndex = index;
    for(let i = 0; i < $fa81208e0a0a8f4a$var$cards.length; i++){
        const card = $fa81208e0a0a8f4a$var$cards[i];
        card.classList.add("no-transition");
    }
    $fa81208e0a0a8f4a$var$updateCarousel();
    for(let i = 0; i < $fa81208e0a0a8f4a$var$cards.length; i++){
        const card = $fa81208e0a0a8f4a$var$cards[i];
        card.offsetHeight;
        card.classList.remove("no-transition");
    }
}
function $fa81208e0a0a8f4a$var$updateCarousel() {
    for(let i = 0; i < $fa81208e0a0a8f4a$var$cards.length; i++){
        const card = $fa81208e0a0a8f4a$var$cards[i];
        card.style.transform = `translateX(calc(-${$fa81208e0a0a8f4a$var$currentIndex * 100}%)`;
        if (window.innerWidth > 1000 && i !== $fa81208e0a0a8f4a$var$currentIndex) card.style.transform += `scale(0.8)`;
        if (window.innerWidth < 428) card.style.transform += `scale(0.84)`;
        $fa81208e0a0a8f4a$var$updateDesc();
    }
}
function $fa81208e0a0a8f4a$var$updateDesc() {
    switch($fa81208e0a0a8f4a$var$currentIndex){
        case 1:
            $fa81208e0a0a8f4a$var$associateDesc.innerHTML = `
      <h2>Lilly Lewarne Architects</h2>
      <p>Lilly Lewarne Architects are a RIBA Chartered Practice located within a converted warehouse in Truro. They have over 25 years of experience in the county, a depth of local knowledge and strong reputation for excellent design. The Lilly Lewarne team are experienced in commercial, educational, healthcare, leisure, spa and hotel projects, as well as all aspects of residential architecture.</p>
      `;
            break;
        case 2:
            $fa81208e0a0a8f4a$var$associateDesc.innerHTML = `
      <h2>MBA Consulting</h2>
      <p>Formed and set up in 1990 under the name Michael Beardsall Associates and later rebranding to MBA Consulting, MBA have gained particular expertise in the areas of healthcare, major industrial development, infrastructure for housing development, appraisal of existing buildings, and insurance related work.</p>
      `;
            break;
        case 3:
            $fa81208e0a0a8f4a$var$associateDesc.innerHTML = `
      <h2>CSA Architects</h2>
      <p>CSA Architects is a design-led RIBA Chartered Practice based in Truro, Cornwall. Established in 1990 and with a longstanding reputation in Cornwall, they provide full architectural services on a range of projects including private homes, residential developments and commercial & leisure projects.</p>
      `;
            break;
        case 4:
            $fa81208e0a0a8f4a$var$associateDesc.innerHTML = `
      <h2>Andrew Mills Surveyors</h2>
      <p>Andrew Mills Surveyors is an independent practice of Chartered Building Surveyors with offices in Exmouth and Budleigh Salterton, near Exeter, East Devon. Established in 1977 the practice has experience of all types of commercial and residential properties and offers a full range of Building Surveying services throughout the South West.</p>
      `;
            break;
        case 5:
            $fa81208e0a0a8f4a$var$associateDesc.innerHTML = `
      <h2>A-Tec Design</h2>
      <p>A-Tec Design are a \u{2018}Chartered Institute of Architectural Technologists\u{2019} registered practice, started by Daren Thomas in 1996, providing a professional architectural design service throughout Cornwall and the South of England.</p>
      `;
            break;
        default:
            $fa81208e0a0a8f4a$var$associateDesc.innerHTML = `
      <h2>P Chapman Construction</h2>
      <p>Based in the heart of Truro, P Chapman Construction are known for building unique beautiful luxury homes as well as renovating and extending existing properties. They build all over Cornwall utilising a team of multi-skilled people and excellent working relationships with architects, engineers, specialist desingers and many other services.</p>
      `;
            break;
    }
    $fa81208e0a0a8f4a$var$currentIndex == 0 || $fa81208e0a0a8f4a$var$currentIndex;
}
window.addEventListener("resize", ()=>{
    $fa81208e0a0a8f4a$var$updateCarousel();
});


//# sourceMappingURL=associates.d1bae1b9.js.map
